import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";

import type { ICategory } from "app/common/services/categoryService.types";
import { i18nFilter } from "app/filters/i18nFilter";

interface IAdvancedEditingProps {
    customIndustry: ICategory;
    navigateToCategory: (options: { toState?: string; customIndustry: ICategory }) => void;
}

const { carbon, blue } = colorsPalettes;

const Text = styled.span`
    ${setFont({ $size: 14, $color: carbon[400], $weight: 400 })};
`;
const Container = styled.div`
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    background-color: ${blue[100]};
    align-items: center;
    padding: 6px 16px;
    border-radius: 4px;
    min-height: 44px;
    box-sizing: border-box;
`;

const ButtonText = styled.span`
    color: ${blue[400]};
    font-size: 14px;
    font-weight: 700;
    font-family: "DM Sans";
    cursor: pointer;

    &:hover {
        color: ${blue[500]};
    }
`;

export const AdvancedEditing: FC<IAdvancedEditingProps> = (props) => {
    const { customIndustry, navigateToCategory } = props;
    const onClick = () => navigateToCategory({ toState: "market_research_builder", customIndustry });
    const i18n = i18nFilter();
    return (
        <Container>
            <Text>{i18n("market.builder.edit.advanced.title")}</Text>
            <ButtonText onClick={onClick}>{i18n("market.builder.edit.advanced.button")}</ButtonText>
        </Container>
    );
};
